<template>
  <div class="documentList dd">
    <div class="documentContent">
      <div class="inner">
        <div class="documentInner" v-show="tableData.length>0">
          <div class="screenTop">
            <p class="title">订单管理</p>
            <div class="screenContent">
              <span class="name">文档名称</span>
              <el-input v-model="name" class="screenInput" placeholder="文档关键词"></el-input>
              <span class="name">签署方</span>
              <el-input v-model="documentTitle" class="screenInput" placeholder="签署方关键词"></el-input>
              <el-button type="warning" style="margin-left: 30px" class="button" @click="search">搜索</el-button>
              <el-button class="button" @click="re">重置</el-button>
            </div>
          </div>
          <div class="documentListContent">
            <p class="tips">
              可发文档总数： <i>{{balance}}份</i>
            </p>
            <el-table
              :data="tableData"
              class="lxrTable"
              style="width: 100%"
            >
              <el-table-column
                prop="contractName"
                label="文档名称"
                width="180">
              </el-table-column>
              <el-table-column
                prop="creater"
                label="发起人"
                sortable
                width="180">
              </el-table-column>
              <el-table-column
                prop="signer"
                label="签署方">
              </el-table-column>
              <el-table-column
                prop="balance"
                label="剩余份数"
                sortable>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间">
              </el-table-column>
              <el-table-column
                prop="completeTime"
                label="完成时间">
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="20"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="documentInner" v-show="tableData.length==0">
          <div style="font-size: 18px;text-align: center;background: #ffffff;line-height: 120px">暂无已完成的订单</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        lxrTitle: '新建联系人',
        documentTitle: '',
        name: '',
        date: '',
        showWindow: false,
        radio: '1',
        total: 123,
        qymc: '',
        userType: 1,
        tableData: [{contractName:'123123',creater:'123123',signer:'签署方',balance:'qweqwe', createTime:'qwdqwd', completeTime:'qwdqwd'}],
        nowPage: 0,
        balance: 0,
      }
    },
    created() {
      this.getData({})
    },
    methods: {
      handleCurrentChange(n) {
        this.nowPage = n - 1;
        this.getData({})
      },
      search() {
        let _this = this;
        _this.nowPage = 0;
        this.getData({})
      },
      re() {
        let _this = this;
        _this.name = '';
        _this.documentTitle = '';
        _this.nowPage = 0;
        this.getData({})
      },
      getData(data) {
        let _this = this;
        data.page_data = {current_page: _this.nowPage};
        data.form_data = {
          "name": _this.name,
          "signUser": _this.documentTitle
        };
        _this.ajpost('/api/user/findOrderList',data,function (datas) {
          _this.tableData  = datas.data.list.list;
          _this.total  = datas.data.list.total;
          _this.balance  = datas.data.balance
        })
      }
    }
  }
</script>
<style>
  @import "../../assets/less/dd.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/dd.vue